import { RewardCategories } from '@/api/Trading-Accounts/Types/RewardsHubDto'
import * as Yup from 'yup'

export const validationSchema = Yup.object({
  internalName: Yup.string().required('Required'),

  displayName: Yup.string().required('Required'),

  rewardCategoryId: Yup.number().min(1, 'Required').required('Required'),

  defaultExpirationInDays: Yup.number()
    .min(1, 'Expiration must be at least 1 day')
    .required('Required'),

  spinRewardConfiguration: Yup.object()
    .nullable()
    .when('rewardCategoryId', {
      is: RewardCategories.SPIN,
      then: () =>
        Yup.object({
          amountOfSpins: Yup.number().min(1, 'Required').required('Required'),

          luckyDrawCampaignId: Yup.string().required('Required'),
        }),
      otherwise: () => Yup.object().nullable(),
    }),

  bonusRewardConfiguration: Yup.object()
    .nullable()
    .when('rewardCategoryId', {
      is: RewardCategories.BONUS,
      then: () =>
        Yup.object({
          bonusCampaignId: Yup.string().required('Required'),
        }),
      otherwise: () => Yup.object().nullable(),
    }),

  tradingViewRewardConfiguration: Yup.object()
    .nullable()
    .when('rewardCategoryId', {
      is: RewardCategories.TRADING_VIEW,
      then: () =>
        Yup.object({
          tradingViewPlanId: Yup.string().required('Required'),
        }),
      otherwise: () => Yup.object().nullable(),
    }),
})
